export class LoggingInfo {
    private MachineName: string;
    private AppName: string;
    private AppSource: string;
    private AppMethod: string;
    private CustomMessage: string;
    private Ex: string;
    private LogLevel: string;

    private Environment: string;
    private AppFileName: string;
    private UserEmail: string;
    private UserID: number;
    private AuthUserID: number;
    private HospID: number;
    private HospUnitID: number;
    private IndID: number;
    private SubscriptionID: number;
    private AvailableSubscriptions: string;

    constructor(env: string, machine: string, appName: string, appSource: string, appMethod: string,
                userID: number = 0, userEmail: string = '', authUserID: number = 0, appFileName: string,
                hospID: number = 0, unitID: number = 0, indID: number = 0, subscriptionID: number, availableSubscriptions: string, message: string, ex: string, logLevel: string) {
        this.Environment = env;
        this.MachineName = machine;
        this.AppName = appName;
        this.AppSource = appSource;
        this.AppMethod = appMethod;
        this.AppFileName = appFileName;
        this.UserID = userID;
        this.UserEmail = userEmail;
        this.AuthUserID = authUserID;
        this.HospID = hospID;
        this.HospUnitID = unitID;
        this.IndID = indID;
        this.SubscriptionID = subscriptionID;
        this.AvailableSubscriptions = availableSubscriptions;
        this.CustomMessage = message;
        this.Ex = ex;
        this.LogLevel = logLevel;
    }

    get machineName(): string { return this.MachineName; }
    set machineName(value: string) { this.MachineName = value; }

    get appName(): string { return this.AppName; }
    set appName(value: string) { this.AppName = value; }

    get appSource(): string { return this.AppSource; }
    set appSource(value: string) { this.AppSource = value; }

    get appMethod(): string { return this.AppMethod; }
    set appMethod(value: string) { this.AppMethod = value; }

    get customMessage(): string { return this.CustomMessage; }
    set customMessage(value: string) { this.CustomMessage = value; }

    get ex(): string { return this.Ex; }
    set ex(value: string) { this.Ex = value; }

    get logLevel(): string { return this.LogLevel; }
    set logLevel(value: string) { this.LogLevel = value; }

    get environment(): string { return this.Environment; }
    set environment(value: string) { this.Environment = value; }

    get appFileName(): string { return this.AppFileName; }
    set appFileName(value: string) { this.AppFileName = value; }

    get userEmail(): string { return this.UserEmail; }
    set userEmail(value: string) { this.UserEmail = value; }

    get userID(): number { return this.UserID; }
    set userID(value: number) { this.UserID = value; }

    get authUserID(): number { return this.AuthUserID; }
    set authUserID(value: number) { this.AuthUserID = value; }

    get hospID(): number { return this.HospID; }
    set hospID(value: number) { this.HospID = value; }

    get hospUnitID(): number { return this.HospUnitID; }
    set hospUnitID(value: number) { this.HospUnitID = value; }

    get indID(): number { return this.IndID; }
    set indID(value: number) { this.IndID = value; }
    
    get availableSubscriptions(): string { return this.AvailableSubscriptions; }
    set availableSubscriptions(value: string) { this.AvailableSubscriptions = value; }

    get subscriptionID(): number { return this.SubscriptionID; }
    set subscriptionID(value: number) { this.SubscriptionID = value; }
}
